export enum QuotaLimits {
  FULL = 1,
  WARNING = 0.95,
}
